module.exports = __webpack_public_path__ + "static/hero-8dbc223957b335fd23a5d2ef41d16f83.svg";